var _linearGradient, _path, _linearGradient2, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _rect, _polygon, _rect2, _linearGradient3, _polygon2, _defs, _clipPath, _path9, _path10, _polygon3, _rect3, _path11, _polygon4, _path12, _polygon5, _path13, _polygon6, _path14, _polygon7, _path15, _rect4, _path16, _linearGradient4, _path17, _path18, _linearGradient5, _path19, _polygon8, _linearGradient6, _polygon9, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBranding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon-branding",
    viewBox: "0 0 310.4 336",
    width: 288,
    height: 288,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 263.446,
    x2: 114.769,
    y1: -35.597,
    y2: 254.034,
    gradientTransform: "matrix(1.0458 .0014 .0014 1.0425 -7.752 -18.719)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#e7e7e7",
    className: "stopColorefdfed svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6f6f6",
    className: "stopColorfdf0f6 svgShape"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon-background",
    fill: "#D99938",
    d: "M0.9,119.5C-3.2,65.7,107.4-40.2,185.7,17.8c44.3,32.8,33.5,62.4,70.3,82.8    c31.3,17.4,55,57.5,51.5,111.9c-3.7,57.6-67.8,106.6-123.4,117.1C107.9,344,56.3,305.4,39.4,280.8c-22.8-33-7.3-51-10.5-81.6 C24.5,158.6,3.2,149.7,0.9,119.5z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 167.31,
    x2: 273.967,
    y1: 173.203,
    y2: 173.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#e2c275",
    className: "stopColorf38099 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eadca6",
    className: "stopColorf7a6a5 svgShape"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M190.4,225l-21.6-21.6c-2-2-2-5.2,0-7.2l74.8-74.8c2-2,5.2-2,7.2,0l21.6,21.6c2,2,2,5.2,0,7.2 L197.7,225C195.7,227,192.4,227,190.4,225z M256.2,137.6c-1.7-1.7-4.6-1.7-6.3,0c-1.7,1.7-1.7,4.6,0,6.3c1.7,1.7,4.6,1.7,6.3,0 C258,142.2,258,139.3,256.2,137.6z",
    className: "ruler-part hover"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#7f4924",
    d: "M173.9,208.5l-5.1-5.1c-2-2-2-5.2,0-7.2l74.8-74.8c2-2,5.2-2,7.2,0l5.1,5.1L173.9,208.5z",
    className: "ruler-part hover color7f245f svgShape"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "ruler-part hover color000 svgShape",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#f4f4f4",
    points: "246.5 130.5 240.5 124.5 241.4 123.6 247.4 129.6 246.5 130.5",
    className: "colorF6ECF4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f4f4f4",
    points: "240.3 136.7 234.3 130.7 235.2 129.8 241.2 135.8 240.3 136.7",
    className: "colorF6ECF4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f4f4f4",
    points: "234.1 142.9 228.1 136.9 229 136 235 142 234.1 142.9",
    className: "colorF6ECF4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f4f4f4",
    points: "227.9 149.1 221.9 143.1 222.8 142.2 228.8 148.2 227.9 149.1",
    className: "colorF6ECF4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f4f4f4",
    points: "221.7 155.3 215.7 149.3 216.6 148.4 222.6 154.4 221.7 155.3",
    className: "colorF6ECF4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f4f4f4",
    points: "215.5 161.5 209.5 155.5 210.4 154.6 216.4 160.6 215.5 161.5",
    className: "colorF6ECF4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f4f4f4",
    points: "209.3 167.7 203.3 161.7 204.2 160.8 210.2 166.8 209.3 167.7",
    className: "colorF6ECF4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f4f4f4",
    points: "203.1 173.9 197.1 167.9 198 167 204 173 203.1 173.9",
    className: "colorF6ECF4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f4f4f4",
    points: "196.9 180.1 190.9 174.1 191.8 173.2 197.8 179.2 196.9 180.1",
    className: "colorF6ECF4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f4f4f4",
    points: "190.7 186.3 184.7 180.3 185.6 179.4 191.6 185.4 190.7 186.3",
    className: "colorF6ECF4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f4f4f4",
    points: "184.5 192.5 178.5 186.5 179.4 185.6 185.4 191.6 184.5 192.5",
    className: "colorF6ECF4 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f4f4f4",
    points: "178.3 198.7 172.3 192.7 173.2 191.8 179.2 197.8 178.3 198.7",
    className: "colorF6ECF4 svgShape"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#684127",
    d: "M88.9,186.5l-69.1-69.1c4-3.1,9-3.7,12.2-1.3l63.6,63.6L88.9,186.5z",
    className: "pen-part hover color582768 svgShape"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#664026",
    d: "M111.7,163.7l-16.1,16.1L32,116.1l0,0c0,0,0-0.1-0.1-0.1c0,0,0.1,0.1,0.1,0.1 c-2.6-3.6-1.6-9.4,2.5-13.5c4.1-4.1,9.9-5.1,13.5-2.5c0,0,0-0.1-0.1-0.1c0,0,0.1,0,0.1,0.1l0,0L111.7,163.7z",
    className: "pen-part hover color662666 svgShape"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#684127",
    d: "M48.1,100c-2.3-3.2-1.8-8.2,1.3-12.2l69.1,69.1l-6.8,6.8L48.1,100z",
    className: "pen-part hover color582768 svgShape"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M49.4,87.8c-3.1,4-3.7,9-1.3,12.2l0,0c0,0-0.1,0-0.1-0.1c0,0,0.1,0.1,0.1,0.1 c-3.6-2.6-9.4-1.6-13.5,2.5c-4.1,4.1-5.1,9.9-2.5,13.5c0,0-0.1,0-0.1-0.1c0,0,0,0.1,0.1,0.1l0,0c-3.2-2.3-8.2-1.8-12.2,1.3L20,88 L49.4,87.8z",
    className: "pen-part hover colorFFF svgShape"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#664026",
    d: "M19.9,102.4L20,88l14.5-0.1c-1.9,2.8-4.1,5.4-6.6,7.9C25.3,98.4,22.7,100.5,19.9,102.4z",
    className: "pen-part hover color662666 svgShape"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 9.5,
    height: 9.8,
    x: 91.1,
    y: 181.8,
    fill: "#917561",
    transform: "rotate(134.991 95.854 186.68)",
    className: "color617591 svgShape"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#bab291",
    points: "95.8 179.8 111.8 163.8 118.8 170.7 102.7 186.8",
    className: "color91A0BA svgShape"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 9.5,
    height: 9.8,
    x: 113.9,
    y: 159,
    fill: "#917561",
    transform: "rotate(135.008 118.67 163.861)",
    className: "color617591 svgShape"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 60.263,
    x2: 151.982,
    y1: 75.058,
    y2: 188.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#a65822",
    className: "stopColora62257 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454,
    stopColor: "#864c24",
    className: "stopColor86245e svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#684127",
    className: "stopColor582768 svgShape"
  }))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#c)",
    points: "181.7 58.4 71.1 58.4 71.1 99.4 71.1 153.4 71.1 263.8 221.4 263.8 221.4 153.4 221.4 137.7 221.4 98"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "d",
    points: "221.4 263.8 221.4 153.4 221.4 98 181.7 58.4 71.1 58.4 71.1 99.4 71.1 153.4 71.1 263.8",
    fill: "#000000",
    className: "color000 svgShape"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#d",
    overflow: "visible"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#684126",
    d: "M50.6,242.3c38.6-40,16.5-19.3,53.6-57.9l-1.7-1.7l7.3-7.3l2,2c2.5-2.5,4.9-5.2,7.1-8.3 c5.2-7,9.1-14.3,11.6-21.2c7.2,4.4,16.7,5.9,25.1,3.4c3.7-1.1,6.8-3,9.2-5.2l4.2,4.2l-0.1,0.1l-24.1,24.1c-1.6-1-3.5-1.2-4.5-0.1 c-1.3,1.3-0.9,3.8,1,5.6c1.8,1.8,4.4,2.3,5.6,1c1-1,0.9-2.9-0.1-4.6l24.2-24.1l0.1-0.1l4.2,4.2c-2.3,2.4-4.1,5.4-5.2,9.2 c-2.5,8.4-1,17.9,3.4,25.1c-6.9,2.4-14.3,6.3-21.2,11.6c-3,2.3-5.8,4.7-8.3,7.2l2,2l-7.3,7.3l-1.7-1.7 c-38.6,37.2-17.9,15.1-57.9,53.7C55.4,294.4,27,265.9,50.6,242.3z",
    clipPath: "url(#e)",
    opacity: 0.7,
    className: "color5A2668 svgShape"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M139.8,218L139.8,218c-13.6,0-26.4-5.3-36-14.9c-19.8-19.8-19.8-52.1,0-72 c9.6-9.6,22.4-14.9,36-14.9c13.6,0,26.4,5.3,36,14.9c19.8,19.8,19.8,52.1,0,72C166.1,212.7,153.4,218,139.8,218L139.8,218z  M139.8,118.7c-12.9,0-25.1,5-34.2,14.2c-18.8,18.8-18.8,49.5,0,68.4c9.1,9.1,21.3,14.2,34.2,14.2c12.9,0,25-5,34.2-14.2 c18.8-18.8,18.8-49.5,0-68.4C164.8,123.8,152.7,118.7,139.8,118.7L139.8,118.7z",
    className: "circle-part hover colorFFF svgShape"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    points: "206.1 165.5 141.3 100.8 143.1 98.9 207.9 163.7 206.1 165.5",
    className: "colorFFF svgShape"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 9.6,
    height: 9.6,
    x: 100.3,
    y: 127.6,
    fill: "#9e5421",
    className: "circle-part hover color9E2158 svgShape"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M105.1,141l-8.6-8.6l8.6-8.6l8.6,8.6L105.1,141L105.1,141z M100.2,132.4l5,5l5-5l-5-5 L100.2,132.4L100.2,132.4z",
    className: "circle-part hover colorFFF svgShape"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#6d4225",
    points: "181.2 201.7 174.4 194.9 167.6 201.7 174.4 208.5",
    className: "circle-part hover color6D2563 svgShape"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M174.4,210.3l-8.6-8.6l8.6-8.6l8.6,8.6L174.4,210.3L174.4,210.3z M169.4,201.7l5,5l5-5l-5-5 L169.4,201.7L169.4,201.7z",
    className: "circle-part hover colorFFF svgShape"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#6d4225",
    points: "181.4 132.2 174.6 125.4 167.8 132.2 174.6 139",
    className: "circle-part hover color6D2563 svgShape"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M174.6,140.8l-8.6-8.6l8.6-8.6l8.6,8.6L174.6,140.8L174.6,140.8z M169.6,132.2l5,5l5-5l-5-5 L169.6,132.2L169.6,132.2z",
    className: "circle-part hover colorFFF svgShape"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    points: "111.2 202.4 104.4 195.6 97.6 202.4 104.4 209.2",
    className: "colorFFF svgShape"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#793f17",
    d: "M104.4,211l-8.6-8.6l8.6-8.6l8.6,8.6L104.4,211L104.4,211z M99.5,202.4l5,5l5-5l-5-5 L99.5,202.4L99.5,202.4z",
    className: "color175079 svgShape"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#804924",
    points: "146.8 97.6 140 90.8 133.2 97.6 140 104.4",
    className: "color802460 svgShape"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M140,106.2l-8.6-8.6L140,89l8.6,8.6L140,106.2L140,106.2z M135,97.6l5,5l5-5l-5-5L135,97.6 L135,97.6z",
    className: "anchor-part anchor-part--1 colorFFF svgShape"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 9.6,
    height: 9.6,
    x: 204.4,
    y: 162,
    fill: "#664026",
    transform: "rotate(45.017 209.232 166.847)",
    className: "color622666 svgShape"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M209.2,175.5l-8.6-8.6l8.6-8.6l8.6,8.6L209.2,175.5L209.2,175.5z M204.2,166.8l5,5l5-5l-5-5 L204.2,166.8L204.2,166.8z",
    className: "anchor-part anchor-part--2 colorFFF svgShape"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 34.477,
    x2: 131.021,
    y1: 224.068,
    y2: 224.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#dbba6b",
    className: "stopColordb6b86 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.086,
    stopColor: "#dcbb6d",
    className: "stopColordc6d87 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eadca6",
    className: "stopColorf7a6a5 svgShape"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M71.8,263.5c-23.6,23.6-52.1-4.8-28.4-28.5c39-40.4,15.9-18.8,54.9-59.2 c10.9,10.9,21.8,21.8,32.7,32.7C90.6,247.6,112.2,224.4,71.8,263.5z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M80,216.7c-3.7,3.4-9.3,8.9-20.7,20.1c-5.1,5.1-9.7,8.1-13.5,9.4c1.4-3.8,4.4-8.5,9.4-13.5 c34.5-35.1,14.5-15.9,49-51c1.6,1.6,3.2,3.2,4.7,4.7C85.8,210.1,88.4,207.9,80,216.7z",
    className: "colorFFF svgShape"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 120.752,
    x2: 137.165,
    y1: 199.182,
    y2: 172.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#e3e3e3",
    className: "stopColorecdbec svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    className: "stopColorfff svgShape"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M148.5,144.1c3.7-1.1,6.8-3,9.2-5.2l4.2,4.2l-0.1,0.1l-24.1,24.1c-1.6-1.1-3.5-1.2-4.5-0.1 c-1.3,1.3-0.9,3.8,1,5.6c1.8,1.8,4.4,2.3,5.6,1c1-1,0.9-2.9-0.1-4.6l24.1-24.1l0.1-0.1l4.2,4.2c-2.3,2.4-4.1,5.4-5.2,9.2 c-2.5,8.4-1,17.9,3.4,25.1c-6.9,2.4-14.3,6.3-21.2,11.6c-5,3.8-9.4,7.9-12.9,12.1c-4.4-5.5-9.5-11.2-15.3-17 c-5.8-5.8-11.5-10.9-17-15.3c4.2-3.5,8.3-7.8,12.1-12.9c5.2-7,9.1-14.3,11.6-21.2C130.6,145.1,140.1,146.6,148.5,144.1z"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#c36a2d",
    points: "131.4 211.5 95.3 175.5 102.6 168.1 138.6 204.2",
    className: "colorCE5C59 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      transformOrigin: "221.65px 258.25px"
    },
    fill: "#7f4924",
    points: "254.1 246.9 221.7 236.3 189.2 225.8 199.8 258.2 210.3 290.7 221.7 268.5 239 285.8 249.3 275.6 231.9 258.3",
    className: "cursor-part hover origin-center color7f245f svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      transformOrigin: "221.65px 253.45px"
    },
    fill: "#a55722",
    points: "221.7 236.3 189.2 225.8 189.6 226.9 243.8 281.1 249.3 275.6 231.9 258.3 254.1 246.9",
    className: "cursor-part hover origin-center colorA52257 svgShape"
  }), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 181.706,
    x2: 221.366,
    y1: 78.218,
    y2: 78.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#a65822",
    className: "stopColora62257 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454,
    stopColor: "#864c24",
    className: "stopColor86245e svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#684127",
    className: "stopColor582768 svgShape"
  }))), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#h)",
    points: "181.7 98 221.4 98 181.7 58.4"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "154.35px 26.55px"
    },
    fill: "#ffffff",
    d: "M152.4,21.6v3h-3c-1,0-1.9,0.8-1.9,1.9v0.1c0,1,0.8,1.9,1.9,1.9h3v3c0,1,0.8,1.9,1.9,1.9h0.1 c1,0,1.9-0.8,1.9-1.9v-3h3c1,0,1.9-0.8,1.9-1.9v-0.1c0-1-0.8-1.9-1.9-1.9h-3v-3c0-1-0.8-1.9-1.9-1.9h-0.1 C153.2,19.7,152.4,20.6,152.4,21.6z",
    className: "star star-1 origin-center colorFFF svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      transformOrigin: "141.35px 294.95px"
    },
    fill: "#dbdbdb",
    d: "M139.6,290.4v2.8h-2.8c-1,0-1.7,0.8-1.7,1.7v0.1c0,1,0.8,1.7,1.7,1.7h2.8v2.8 c0,1,0.8,1.7,1.7,1.7h0.1c1,0,1.7-0.8,1.7-1.7v-2.8h2.8c1,0,1.7-0.8,1.7-1.7v-0.1c0-1-0.8-1.7-1.7-1.7h-2.8v-2.8 c0-1-0.8-1.7-1.7-1.7h-0.1C140.3,288.7,139.6,289.5,139.6,290.4z",
    className: "star star-2 origin-center colorE5D0E6 svgShape"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 63.1,
    cy: 42.9,
    r: 3.4,
    fill: "#ffffff",
    className: "colorFFF svgShape"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranding);
export default __webpack_public_path__ + "static/media/branding.0b91b862.svg";
export { ForwardRef as ReactComponent };